import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import Portal from '../../assets/formComponents/Portal.svg';
import apiHost from '../../apiHost';
import { BlueButton, H1, H2 } from '../StyledComponents';
import EsperLogoBlue from '../../assets/v2/esper_light.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import axios from 'axios';
import { Link, navigate, graphql, StaticQuery } from 'gatsby';
import { ImgDesktop } from './EsperSignUpFormComponent';

const barberpole = keyframes`
  100% {
    background-position: 100% 100%;
  }
`;

export const BlueButtonNew = styled(BlueButton)`
  background-color: #664eab;
  min-width: 18rem;
  width: fit-content !important;
  margin: 0rem !important;
  font-size: 22px;
  height: 50px;
  @media (min-width: 1280px) {
    min-width: 350px;
  }
  @media (min-width: 780px) and (max-width: 960px) {
    min-width: 350px;
  }
  @media (max-width: 400px) {
    min-width: 250px;
  }
  background-image: ${(props: { isLoading: boolean }) =>
    props.isLoading
      ? `repeating-linear-gradient(
      -45deg,
      #7a55a5,
      #7a55a5 1rem,
      #634487 1rem,
      #634487 2rem
    )`
      : ''};

  animation: ${(props: { isLoading: boolean }) =>
    props.isLoading
      ? css`
          ${barberpole} 4s linear reverse infinite
        `
      : ``};
  background-size: 200% 200%;
  /* justify-self: center; */

  @media (max-width: 768px) {
    font-size: 16px !important;
  }
`;

const WhiteButton = styled(BlueButtonNew)`
  background: transparent;
  border: 1px solid #664eab;
  color: #664eab;
  box-shadow: none;
`;

// @ts-ignore
const StyledInputs = styled.input`
  :focus {
    color: #495057;
    background-color: ##f4f5f7;
    border: rgb(76, 154, 255) 2px solid;
    outline: 0;
    box-shadow: 0 0 0 0.1rem rgba(0, 123, 255, 0.25);
    color: black;
    background-image: none;
  }

  background-color: ##f4f5f7;
  box-shadow: ${(props: { error: boolean }) =>
    props.error ? '0 0 0 0.1rem #fd7e7e5e' : 'none'};
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  @media (max-width: 520px) {
    font-size: 12px;
  }
  line-height: 1.43;
  ::placeholder {
    color: rgba(107, 124, 147, 0.6);
    opacity: 1; /* Firefox */
  }
  padding: 1.07em 0.5em;
  margin-top: 10px;
  height: 50px;
  width: 100%;
  min-width: 18rem;
  border: solid 2px #cacaca;
  border-color: ${(props: { error: boolean }) =>
    props.error ? 'rgb(222, 53, 11)' : 'rgba(107, 124, 147, 0.43)'};
  padding: 0.475rem 0.75rem 0.475rem 1.5rem;
  border-radius: 4px;
  background-position-y: center;
  background-position-x: 0.5rem;
  background-repeat: no-repeat;
  text-indent: 20px;
  background-size: 18px 18px;
  @media (min-width: 1280px) {
    min-width: 350px;
  }
  @media (min-width: 780px) and (max-width: 960px) {
    min-width: 350px;
  }
  @media (max-width: 400px) {
    min-width: 250px;
  }
`;

const FormComponent = styled.div`
  display: grid;
  position: relative;
  padding: 0;
  justify-self: center;
  min-height: 100vh;
  /* box-shadow: 3px 2px 26px 0 rgba(112, 112, 112, 0.15); */
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  padding-bottom: 0rem !important;
  padding-top: 0rem !important;
  /* margin-top: 12rem; */
  justify-items: center;
`;

const FormComponentLeft = styled.div`
  padding: 7rem 6rem;
  display: grid;
  align-content: center;
  grid-column: span 1;
  justify-items: center;
  background-image: linear-gradient(
    34deg,
    #9a6ad3 -25%,
    #7757b8 -2%,
    #5847a0 52%
  );
  width: 100%;

  @media (max-width: 1440px) {
    padding: 7rem 3rem;
  }
  @media (max-width: 768px) {
    border-radius: 8px 8px 0px 0px;
    display: none;
  }
  @media (max-width: 520px) {
    padding: 7rem 5rem;
    display: none;
  }
  @media (max-width: 400px) {
    padding: 6rem 2rem;
  }
`;

const FormComponentRight = styled.div`
  padding: 2rem 2rem 1.5rem 3rem;

  grid-column: span 2;
  background: #ffffff;
  display: grid;
  grid-gap: 6rem;
  padding-left: 15%;
  padding-right: 20%;
  align-content: center;
  justify-content: left;
  width: 100%;
  border-radius: 0px 8px 8px 0px;
  @media (max-width: 768px) {
    border-radius: 0px 0px 8px 8px;
  }
  @media (max-width: 520px) {
    padding: 24px 8px;
    border-radius: 5px;
    display: grid;
    width: 90%;
  }
`;

const EsperLogo = styled(Link)`
  justify-self: left;
  position: absolute;
  left: 5rem;
  top: 0;
`;

const SignupButton = styled.div`
  height: 50px;
  padding: 0rem 2rem;
  border: solid 1px #4b5176 !important;
  font-family: 'Nunito Sans', sans-serif;
  cursor: pointer;
  /* margin: 10px; */
  overflow: hidden;
  border-width: 0;
  outline: none;
  border-radius: 4px;
  color: rgb(80, 95, 121);
  font-size: 16px;
  @media (max-width: 768px) {
    font-size: 14px;
  }
  @media (max-width: 520px) {
    font-size: 12px;
    padding: 0rem 1rem;
    height: 2.5rem;
  }
  /* font-weight: 600; */
  font-style: normal;

  min-width: 18rem;
  font-stretch: normal;
  line-height: normal;
  text-rendering: geometricprecision;
  letter-spacing: normal;
  transition: background-color 0.3s;
  box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 5px 0px !important;
  border-width: 0px;
  text-decoration: none;
  border-radius: 3px;
  display: grid;
  background: #fff;
  text-align: center;
  margin-top: 1rem;
  align-items: center;
  @media (max-width: 400px) {
    min-width: 250px;
  }
`;

const SignupSubText = styled(H2)`
  font-family: 'Nunito Sans', sans-serif;
  text-align: left;
  margin-bottom: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #6c749b;
  @media (max-width: 768px) {
    text-align: left;
    font-size: 14px;
  }
  @media (max-width: 520px) {
    text-align: center;
    padding-left: 10%;
    padding-right: 10%;
  }
`;

const SignUpHeading = styled(H1)`
  color: #654da8;
  margin-top: 1rem;
  text-align: left;
  letter-spacing: -0.85px;

  font-weight: 500;
  margin-bottom: 14px;
  @media (max-width: 768px) {
    width: 100%;
    text-align: left;
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    text-align: center;
  }
`;

const EndpointRightText = styled.div`
  align-self: flex-end;
  font-size: 28px;
  margin-left: 5px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #6c749b;

  @media (max-width: 900px) {
    display: none;
  }
`;
const PasswordMatchError = styled.div`
  font-size: 12px;
  color: #c62828;
  margin-top: 6px;
  max-width: 22rem;
  min-height: 21px;
  margin-bottom: 0.5rem;
  font-family: 'Nunito Sans', sans-serif;
`;

const Forgot = styled(Link)`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  margin-bottom: 1rem;
  font-family: 'Nunito Sans', sans-serif;
`;

const FormComponentLeftTitle = styled(H1)`
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  text-align: center !important;
  letter-spacing: normal;
  color: #ffffff;
  @media (max-width: 320px) {
    font-size: 18px;
  }
`;

const FormComponentItems = styled.div`
  display: grid;
  justify-items: left;
  @media (max-width: 520px) {
    justify-items: center;
  }
`;

interface IState {
  endpoint: string;
  endpointError: boolean;
  endpointLoading: boolean;
}

export default class EsperSignUpClass extends React.PureComponent<any, IState> {
  state = {
    endpoint: '',
    endpointError: false,
    endpointLoading: false,
  };

  handleEndpointChange = (event: any) =>
    this.setState({ endpoint: event.target.value });

  getEndpoint = () => {
    this.setState({ endpointLoading: true });
    axios({
      url: `${apiHost.host}login/`,
      method: 'GET',
      params: {
        endpoint: this.state.endpoint,
      },
    })
      .then((result: any) => {
        this.setState({ endpointLoading: false });
        window.location.replace(
          // this.props?.currentLanguage && this.props?.currentLanguage !== 'en'
          //   ? `https://${result.data.endpoint}.esper.cloud/${this.props.currentLanguage}/login`
          //   :
          `https://${result.data.endpoint}.esper.cloud/login`
        );
      })
      .catch((error: any) => {
        this.setState({ endpointLoading: false, endpointError: true });
        console.log('error', error);
      });
  };

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            andi: file(relativePath: { eq: "v2/signup/andi-signup@3x.png" }) {
              childImageSharp {
                fluid(quality: 85) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }
          }
        `}
        render={(data: any) => (
          <FormComponent style={this.props.style}>
            <FormComponentLeft>
              <EsperLogo
                aria-label="Esper Logo"
                title="Esper Logo"
                to={`${
                  this.props.messages?.locale !== 'en'
                    ? `/${this.props?.messages?.locale}/`
                    : '/'
                }`}
              >
                <LazyLoadImage
                  alt="Esper logo"
                  style={{
                    height: '44px',
                    width: '180px',
                    marginTop: '2rem',
                    marginBottom: '2rem',
                  }}
                  src={EsperLogoBlue}
                />
              </EsperLogo>
              <ImgDesktop
                fluid={data.andi.childImageSharp.fluid}
                loading="lazy"
                alt="Esper Andi"
              />
              <div>
                <FormComponentLeftTitle>
                  {this.props.messages?.LoginPageDontAccount ??
                    'Don’t Have An Account?'}
                </FormComponentLeftTitle>
                <SignupButton
                  id="esper_login__signup_for_free"
                  onClick={() =>
                    navigate(
                      `${
                        this.props.messages?.locale !== 'en'
                          ? `/${this.props?.messages?.locale}/signup`
                          : '/signup'
                      }`
                    )
                  }
                >
                  {this.props.messages?.LoginPageSignupForFree ??
                    'Sign up for free'}
                </SignupButton>
              </div>
            </FormComponentLeft>
            <FormComponentRight>
              <FormComponentItems>
                <SignUpHeading>
                  {this.props.messages?.LoginPageTitle ??
                    'LOGIN TO YOUR ESPER ACCOUNT'}
                </SignUpHeading>
                <SignupSubText>
                  {this.props.messages?.LoginPageDecsription ??
                    " Enter your unique endpoint name below and we'll take you to your account. You can then login with your Esper credentials."}
                </SignupSubText>
                <div
                  style={{
                    display: 'grid',
                  }}
                >
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'auto auto',
                    }}
                  >
                    <StyledInputs
                      id="full-name"
                      aria-label="Full name"
                      error={this.state.endpointError}
                      backgroundImage={Portal}
                      value={this.state.endpoint}
                      maxLength={29}
                      onChange={this.handleEndpointChange}
                      placeholder={
                        this.props.messages?.LoginPageEndPointName ??
                        'Endpoint Name'
                      }
                      type="text"
                      name="Full name"
                    />
                    <EndpointRightText>.esper.cloud</EndpointRightText>
                  </div>
                  <PasswordMatchError id="login-error">
                    {this.state.endpointError === true && (
                      <>
                        <i
                          className="fa fa-exclamation-triangle"
                          aria-hidden="true"
                        />{' '}
                        {this.props.messages
                          ?.LoginPageEndPointNameValidationMessage ??
                          'Please enter a valid endpoint name'}
                      </>
                    )}
                  </PasswordMatchError>

                  <Forgot to="/forgot-endpoint">
                    {this.props.messages?.LoginPageForgotPortalURL ??
                      'Forgot Your Portal URL?'}
                  </Forgot>
                  <BlueButtonNew
                    style={{ textTransform: 'unset' }}
                    isLoading={this.state.endpointLoading}
                    disabled={this.state.endpointLoading}
                    onClick={this.getEndpoint}
                    id="esper_login__login"
                  >
                    {this.props.messages?.WebsiteGeneralLoginCTA ?? 'Login'}
                  </BlueButtonNew>
                </div>
                <div
                  style={{
                    display: 'grid',
                    justifyItems: 'center',
                  }}
                >
                  <MarginDiv>OR</MarginDiv>
                  <WhiteButton
                    style={{ textTransform: 'unset' }}
                    onClick={() =>
                      navigate(
                        this.props.currentLanguage &&
                          this.props?.currentLanguage !== 'en'
                          ? `/${this.props?.currentLanguage}/signup`
                          : '/signup'
                      )
                    }
                    id="esper_login__signup"
                  >
                    {this.props.messages?.WebsiteGeneralSignupCTA ?? 'Sign up'}
                  </WhiteButton>
                </div>
              </FormComponentItems>
            </FormComponentRight>
          </FormComponent>
        )}
      />
    );
  }
}

const MarginDiv = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;
